import React from "react";

import Founder from "./assets/img/team/team-1.jpg";
import Manager from "./assets/img/team/team-2.jpg";
import Director from "./assets/img/team/team-3.jpg";

import './assets/css/style.css';
import './assets/vendor/aos/aos.css';
import './assets/vendor/bootstrap/css/bootstrap.min.css';
import './assets/vendor/bootstrap-icons/bootstrap-icons.css';
import './assets/vendor/boxicons/css/boxicons.min.css';
import './assets/vendor/glightbox/css/glightbox.min.css';
import './assets/vendor/swiper/swiper-bundle.min.css';

const Team = () =>{
    return(
        <section id="team" class="team">
      <div class="container">

        <div class="section-title" data-aos="">
          <h2>Our Lead</h2>
          <p></p>
        </div>

        <div class="row">

          <div class="col-lg-4 col-md-6">
            <div class="member" data-aos="">
              <div class="pic"><img src={Founder} class="img-fluid" alt=""/></div>
              <div class="member-info">
                <h4>Mr. Digvijay Patil</h4>
                <span>Founder & CEO </span>
                <div class="social">
                  <a href=""><i class="bi bi-twitter"></i></a>
                  <a href=""><i class="bi bi-facebook"></i></a>
                  <a href=""><i class="bi bi-instagram"></i></a>
                  <a href=""><i class="bi bi-linkedin"></i></a>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-4 col-md-6">
            <div class="member" data-aos="" data-aos-delay="">
              <div class="pic"><img src={Director} class="img-fluid" alt=""/></div>
              <div class="member-info">
                <h4>Mr. Karan Indulkar</h4>
                <span>Marketing Manager</span>
                <div class="social">
                  <a href=""><i class="bi bi-twitter"></i></a>
                  <a href=""><i class="bi bi-facebook"></i></a>
                  <a href=""><i class="bi bi-instagram"></i></a>
                  <a href=""><i class="bi bi-linkedin"></i></a>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-4 col-md-6">
            <div class="member" data-aos="" data-aos-delay="">
              <div class="pic"><img src={Director} class="img-fluid" alt=""/></div>
              <div class="member-info">
                <h4>Mr. Jayant Patil </h4>
                <span>Director</span>
                <div class="social">
                  <a href=""><i class="bi bi-twitter"></i></a>
                  <a href=""><i class="bi bi-facebook"></i></a>
                  <a href=""><i class="bi bi-instagram"></i></a>
                  <a href=""><i class="bi bi-linkedin"></i></a>
                </div>
              </div>
            </div>
          </div>

        </div>

      </div>
    </section>
    )
}


export default Team;